import * as React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import styled from "@mui/material/styles/styled";
import { QuestionsIF } from "../../QuestionsIF";
import { useTranslate } from "../../../../hooks/useTranslate";
import { GenericButton } from "../../../uiControllers/genericButton";
import { DocQuestion } from "../../DocQuestion";
import {
  numericTimingConfig,
  NumericTimingConfig,
} from "./numericTimingConfig";
import { DurationPicker } from "./ui(Views)/durationPicker";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { Relations } from "shared";
import { QualifiedFeature } from "fe-common/graphql";
//region [[ Styles ]]

const DurationQuestionView = styled("div")(() => ({}));

const DurationQuestionInner = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "15px",
  padding: "26px",
  backgroundColor: KahunColorMap.LightGrayBackground,
  width: "100%",
  borderRadius: "30px",
  flex: 2, // Let it grow over other elements
});

const ContinueButton = styled(GenericButton)({
  width: "100%",
  marginTop: "15px",
});

//endregion [[ Styles ]]
//region [[ Props ]]
export interface DurationQuestionProps extends QuestionsIF {
  config?: NumericTimingConfig;
}

//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]

export const NumericTimingQuestion = ({
  config = numericTimingConfig[Relations.DURATION],
  ...props
}: DurationQuestionProps) => {
  const { onAnswer, answer } = props;
  const { translate } = useTranslate();
  const [qf, setQf] = useState<QualifiedFeature>(null);

  const suggestion = props.question.suggestions[0];
  const suggestionQF = useMemo(() => props.question.suggestions[0].suggestion, [
    props.question,
  ]);

  useEffect(() => {
    if (!answer) setQf(null);
  }, [answer]);

  const handleSubmit = () => {
    onAnswer([qf]);
  };

  const handleNewDuration = useCallback((qf) => {
    setQf(qf);
  }, []);

  const canAnswer =
    qf?.qualifiers?.[0]?.range?.low && qf?.qualifiers?.[0].range.units;

  return (
    <DurationQuestionView>
      <DocQuestion text={suggestion.question.text} miniView={props.miniView} />
      {!answer && (
        <DurationQuestionInner>
          <DurationPicker
            attachToFeature={suggestionQF}
            onDurationPicked={handleNewDuration}
            config={config}
          />
          <ContinueButton
            label={translate("CONTINUE")}
            disabled={!canAnswer}
            onClick={handleSubmit}
          />
        </DurationQuestionInner>
      )}
    </DurationQuestionView>
  );
};
